<div class="p-4">
    <breadcrumb [items]="breadcrumb"></breadcrumb>
    <mat-card>
        <mat-card-content>
            <div class="d-flex align-items-end mb-3">
                <h1 class="fs-3 fw-light mb-0">Dashboard de Prefixos por Beneficiária</h1>
                <button mat-icon-button color="primary" class="d-print-none btn-sm ms-auto" (click)="toggleFilters = !toggleFilters">
                    <mat-icon>tune</mat-icon>
                </button>            
            </div>

            <!-- FILTROS -->            
            <div class="border-top px-1 py-3" *ngIf="toggleFilters">
                <div class="row align-items-end">                      
                    <div class="col-12 col-md-5">
                        <mat-form-field class="w-100">
                            <mat-label>Beneficiária</mat-label>
                            <mat-select [(ngModel)]="filters.beneficiaria" name="beneficiaria">
                                <mat-option *ngFor="let item of beneficiarias" [value]="item.id">
                                    {{ item.nome }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-12 col-md-5">
                        <mat-form-field class="w-100">
                            <mat-label>Data de Operação</mat-label>
                            <input matInput [matDatepicker]="dataOperacao" name="dataOperacao" 
                                autocomplete="off" [(ngModel)]="filters.dataOperacao">
                            <mat-datepicker-toggle matIconSuffix [for]="dataOperacao"></mat-datepicker-toggle>
                            <mat-datepicker #dataOperacao></mat-datepicker>
                        </mat-form-field>                                
                    </div>
                    <div class="col-12 col-md-2">
                        <button mat-flat-button color="accent" class="w-100" (click)="search()" [disabled]="loading">
                            <span *ngIf="!loading">FILTRAR</span>
                            <mat-spinner *ngIf="loading" diameter="20"></mat-spinner>
                        </button>
                    </div>
                </div>
            </div>
            
            <!-- SEÇÃO: PREFIXOS AGUARDANDO EXECUÇÃO -->
            <div class="mt-4">
                <h3 class="fs-5 fw-bold text-primary mb-3">
                    <mat-icon class="align-middle">schedule</mat-icon>
                    Prefixos com DIO(s) Aguardando Execução ({{ prefixosAguardandoExecucao.length }})
                </h3>
                <div class="overflow-x-auto">
                    <table class="table table-bordered table-striped">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Prefixo</th>
                                <th>Numero DIO</th>
                                <th>Status</th>
                                <th>Data de Operacao</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngIf="prefixosAguardandoExecucao.length === 0">
                                <td colspan="4" class="text-center text-muted">Nenhum prefixo aguardando execução</td>
                            </tr>
                            <tr *ngFor="let item of prefixosAguardandoExecucao; let i = index">
                                <td>{{ i + 1 }}</td>
                                <td>{{ item.prefixo }}</td>
                                <td>{{ item.numeroDio }}</td>
                                <td>
                                    <span class="badge bg-warning text-dark">Aguardando Execução</span>
                                </td>
                                <td>{{ item.dataOperacao | date: 'dd/MM/yyyy' }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- SEÇÃO: PREFIXOS CANCELADOS -->
            <div class="mt-4">
                <h3 class="fs-5 fw-bold text-danger mb-3">
                    <mat-icon class="align-middle">cancel</mat-icon>
                    Prefixos com DIOS(s) Cancelados ({{ prefixosCancelados.length }})
                </h3>
                <div class="overflow-x-auto">
                    <table class="table table-bordered table-striped">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Prefixo</th>
                                <th>Numero DIO</th>
                                <th>Status</th>
                                <th>Data de Operacao</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngIf="prefixosCancelados.length === 0">
                                <td colspan="4" class="text-center text-muted">Nenhum prefixo cancelado</td>
                            </tr>
                            <tr *ngFor="let item of prefixosCancelados; let i = index">
                                <td>{{ i + 1 }}</td>
                                <td>{{ item.prefixo }}</td>
                                <td>{{ item.numeroDio }}</td>
                                <td>
                                    <span class="badge bg-danger">Cancelado</span>
                                </td>
                                <td>{{ item.dataOperacao | date: 'dd/MM/yyyy' }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- SEÇÃO: PREFIXOS SEM DIOS ABERTOS -->
            <div class="mt-4">
                <h3 class="fs-5 fw-bold text-secondary mb-3">
                    <mat-icon class="align-middle">info</mat-icon>
                    Prefixos Sem DIOs Abertos ({{ prefixosSemDios.length }})
                </h3>
                <div class="overflow-x-auto">
                    <table class="table table-bordered table-striped">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Prefixo</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngIf="prefixosSemDios.length === 0">
                                <td colspan="2" class="text-center text-muted">Todos os prefixos possuem DIOs abertos</td>
                            </tr>
                            <tr *ngFor="let item of prefixosSemDios; let i = index">
                                <td>{{ i + 1 }}</td>
                                <td>{{ item }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

        </mat-card-content>
    </mat-card>
</div>
